import { FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';
import { Observable, combineLatest } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { IFormlyField, TFieldGroupExtended } from '../../formly-editor/formly-editor.component';

export const OnInitHooks = {
  setFilterHook: (field: TFieldGroupExtended, groups: IFormlyField[], destroyer$: Observable<void>) => {
    if (!field.dataSource || !field.dataSource.filter) {
      return;
    }
    const multiple = field.props!['multiple'] === true;
    const filters = field.dataSource.filter.split(',').reduce((acc, curr) => {
      const filter = curr.trim();
      if (filter) {
        acc.push(filter);
      }
      return acc;
    }, []);
    for (const filterKey of filters) {
      const filterField = findField(filterKey, groups);
      if (!filterField) {
        console.error('field non trovato - impossibile filtrare per un field che non esiste');
        continue;
      }
      if (!filterField.formControl) {
        console.error('il field non ha un form control - è davvero un field o un gruppo?');
        continue;
      }
      field.props.options = combineLatest([field.props.options, filterField.formControl.valueChanges]).pipe(
        map(([values, filter]) => {
          return values.filter((item: any) => {
            if (typeof item == 'object') return item.source[filterKey] === filter || item.source[filterKey] === filter.id;
            else return false;
          });
        })
      );
      filterField.formControl.valueChanges.pipe(takeUntil(destroyer$)).subscribe((c) => {
        field.formControl?.setValue(multiple ? [] : null);
      });
    }
  }
};

function findField(
  key: string,
  fields: FormlyFieldConfig<FormlyFieldProps & { [additionalProperties: string]: any }>[]
): FormlyFieldConfig<FormlyFieldProps & { [additionalProperties: string]: any }> | null {
  for (const item of fields) {
    if (item.fieldGroup) {
      const found = findField(key, item.fieldGroup);
      if (!!found) return found;
    } else {
      if (item.key === key) return item;
    }
  }
  return null;
}
